// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad373ca2","554":"d527d4fe","557":"8b5f613b","641":"f8bf00ea","692":"c6d2089a"}[chunkId] + ".chunk.js";
};